import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  Flex,
} from '@chakra-ui/react'
import React from 'react'

const ApplyBooleanModal = ({
  isOpen,
  onClose,
  onApply,
  onCancel,
  title,
  description,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay bg='blackAlpha.400' />
      <ModalContent
        borderRadius='lg'
        boxShadow='2xl'
        bg='white'
        maxW='400px'
        mx='auto'
      >
        <ModalHeader
          fontWeight='bold'
          fontSize='xl'
          color='purple.700'
          borderBottom='1px solid'
          borderColor='purple.100'
          pb={2}
        >
          {title}
        </ModalHeader>
        <ModalBody>
          <Text color='gray.700' fontSize='md' mb={2}>
            {description}
          </Text>
        </ModalBody>
        <ModalFooter>
          <Flex w='100%' justify='flex-end' gap={3}>
            <Button
              onClick={onCancel}
              variant='outline'
              colorScheme='purple'
              borderRadius='md'
              fontWeight='medium'
            >
              Cancel
            </Button>
            <Button
              onClick={onApply}
              colorScheme='purple'
              borderRadius='md'
              fontWeight='bold'
              boxShadow='md'
            >
              Apply
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default ApplyBooleanModal
